import React, { useState } from "react"
import { Link } from "react-router-dom";
import styled from "styled-components"
import { IRISBlueDivider, TextSpan } from "../components/Common/SharedStyledComponents";
import { IrisColors } from "../css/IRISColors";
import { ReportInfo } from "../interface/ReportInfoInterface";
import SharedLinkForm from "../components/Reports/SharedLinkForm";
import { useDispatch } from "react-redux";
import { clearSharedLink } from "../actions/UserActions";
import { downloadFromUrlWithFallback } from "../sharedUtilities/downloadFromUrl";

import { findReportViaURLPath } from "./DashboardReportsInfo";

interface PropTypes {
    currentReport?: ReportInfo
    currentUrl?: string
    onDownloadPdf?: () => void
    onDownloadData?: () => void
}

const DashboardReportActionsBar = ({ currentReport, currentUrl, onDownloadPdf, onDownloadData }: PropTypes) => {

    if (!currentReport) {
        currentReport = findReportViaURLPath(currentUrl);
    }

    const { methodologyUrl, isSharedReport } = currentReport;
    const isCDDR = currentReport?.nameID === "CONGRESSIONAL_DISTRICT_DETAIL_REPORT";
    const isFactSheet = currentReport?.nameID === "CONGRESSIONAL_DISTRICT_FACTSHEET"
        || currentReport?.nameID === "STATE_LEGISLATIVE_FACTSHEET";

    const [showShare, setShowShare] = useState(false);
    const dispatch = useDispatch();

    const openShare = () => setShowShare(true);
    const closeShare = () => { setShowShare(false); dispatch(clearSharedLink()); }
    const downloadMethodology = async (e) => {
        e.preventDefault();
        if (!methodologyUrl) return;
        await downloadFromUrlWithFallback(methodologyUrl);
    }

    return (
        <>
            <ActionsBar className="report-actions-bar">
                {!isSharedReport &&
                    <ActionLink to="/reports">
                        <ActionText>← All Reports</ActionText>
                    </ActionLink>
                }
                <ActionsGroup>
                    {isCDDR &&
                        <ActionText>
                            <ExternalLink href="#" onClick={(e) => { e.preventDefault(); openShare(); }}>
                                <i className="fa fa-share" style={{ marginRight: "4px" }}></i>Share Report
                            </ExternalLink>
                            <TextSpan bold>{'\u00A0|\u00A0'}</TextSpan>
                        </ActionText>
                    }
                    {(onDownloadPdf || onDownloadData || methodologyUrl) &&
                        <ActionText>
                            {isFactSheet && <>Download:{'\u00A0'}</>}
                            {onDownloadPdf &&
                                <>
                                    <ExternalLink href="#" onClick={(e) => { e.preventDefault(); onDownloadPdf(); }}>
                                        {isFactSheet ? "PDF Report" : "PDF"}
                                    </ExternalLink>
                                    {(onDownloadData || methodologyUrl) &&
                                        <TextSpan bold>{'\u00A0|\u00A0'}</TextSpan>
                                    }
                                </>
                            }
                            {onDownloadData &&
                                <>
                                    <ExternalLink href="#" onClick={(e) => { e.preventDefault(); onDownloadData(); }}>
                                        {isFactSheet ? "Data Files" : "Data"}
                                    </ExternalLink>
                                    {methodologyUrl &&
                                        <TextSpan bold>{'\u00A0|\u00A0'}</TextSpan>
                                    }
                                </>
                            }
                            {methodologyUrl &&
                                <ExternalLink href={methodologyUrl} onClick={downloadMethodology}>
                                    {onDownloadPdf ? "Methodology" : "Download Methodology"}
                                </ExternalLink>
                            }
                        </ActionText>
                    }
                </ActionsGroup>
            </ActionsBar>
            {isCDDR && <SharedLinkForm reportType="congressional-district-detail-report" showModal={showShare} handleClose={closeShare} />}
            <IRISBlueDivider />
        </>
    );
}

const ActionsBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;
    padding-inline: 15px;
    padding-block: 5px;
    background-color: ${IrisColors.white};
`;

const ActionLink = styled(Link)`
    height: 100%;
    font-size: 15px;
    font-weight: 700;
    color: ${IrisColors.irisLogoBlue};
    text-decoration: none;
    &:hover {
        text-decoration: none;
        color: ${IrisColors.irisLogoRed};
        cursor: pointer;
    }
`;

const ActionText = styled.span`
    font-size: 15px;
    font-weight: 700;
    color: ${IrisColors.irisLogoBlue};
`;

const ExternalLink = styled.a`
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
    text-decoration: underline;
    &:hover {
        text-decoration: underline;
        color: ${IrisColors.irisLogoRed};
        cursor: pointer;
    }
`;

const ActionButton = styled.button``;

//<button type="button" className="btn btn-outline-primary float-right" onClick={() => showSharedLinkForm()} >Share Report</button>

const ActionsGroup = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
`;

export default DashboardReportActionsBar;